<template>
  <List
    :total="activities.length"
    v-model="lm"
    :pagination="false"
  >
    <div class="scrollable-table">
      <table class="table table-hover">
        <thead>
          <tr>
            <ListTh
              v-for="column in columns"
              :column-id="column.path || column.title"
              :width="column.width"
              :key="column.title"
            >
              {{ column.label }}
            </ListTh>
            <th>Действия</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in activities"
            :key="row.id"
          >
            <td
              v-for="(col, name) in columns"
              :key="name"
            >
              <template v-if="col.path">
                <template v-if="col.date && typeof _result(row, col.path) === 'string'">
                  {{ _result(row, col.path) }}
                </template>
                <template v-else>
                  {{ _result(row, col.path) }}
                </template>
              </template>
              <template v-else-if="col.date && row[col.title]">
                {{ row[col.title] }}
              </template>
              <template v-else-if="col.icon">
                <i
                  class="bi"
                  :class="row[col.aligned_class]"
                ></i>
              </template>
              <template v-else>
                {{ col.icon }}
                {{ row[col.title] }}
              </template>
            </td>
            <td class="text-center">
              <RouterLink
                class="btn btn-success btn-sm rounded-circle"
                :to="{ name: 'activities.item', params: { id: row.id } }"
                title="Редактировать план"
              >
                <i class="bi bi-pencil-fill"></i>
              </RouterLink>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </List>
</template>
<script setup>
import { result as _result } from 'lodash-es'
import { commons } from '@provise/lib/transformer'
import { useApi } from '@provise/composables/api'
import List from '@provise/components/list/list.vue'
import ListTh from '@provise/components/list/th.vue'
import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@provise/stores/user.js'
import { useActivityStore } from '@/stores/activity'

const props = defineProps({
  filter: {
    type: String,
    default: 'my',
  },
})

const activityStore = useActivityStore()

const columns = [
  { title: 'id', label: 'ID', width: '30px' },
  { title: 'aligned', label: '', aligned_class: 'aligned_class', width: '30px', icon: true },
  {
    title: 'name',
    label: 'Лекарственные препарат',
    path: 'medicine_trademark.name',
    width: '160px',
  },
  {
    title: 'medicinal_form',
    label: 'Лекaрственная форма',
    path: 'medicine_trademark.medicinal_form.value',
    width: '250px',
  },
  {
    title: 'activity_subtype.parent_name',
    label: 'Назначение',
    path: 'activity_subtype.parent_name',
    width: '130px',
    getOptions: activityStore.getOptions
  },
  {
    title: 'activity_subtype.name',
    label: 'Тип назначения',
    path: 'activity_subtype.name',
    width: '150px',
    getOptions: activityStore.getOptionsSub
  },
  {
    title: 'shipment_date_scheduled',
    label: 'Планируемая дата подачи',
    width: '160px',
    date: true,
  },
  {
    title: 'dispatch_date_executed',
    label: 'Фактическая дата подачи',
    path: 'order.dispatch_date_executed',
    width: '180px',
    date: true,
  },
  { title: 'status', label: 'Статус заявки', path: 'order_out.status', width: '160px' },
]

const lm = ref({})
const { user } = storeToRefs(useUserStore())
const { model } = useApi({
  url: 'activities',
  query: { onPage: 500, page: 1, [props.filter]: true },
  watch: lm,
  data: [],
  pick: pick,
})

const activities = computed(() => {
  const u = user.value || {}
  const a = model.value || []

  const activities = a.filter(a => {
    if (!u.id) {
      return false
    }

    if (a.order.length > 0) {
      let all_deleted = true
      for (let ord of a.order) {
        if (!ord.deleted) {
          all_deleted = false
          break
        }
      }
      if (!all_deleted) return false
    }

    return (u.roles || []).some(r => r.id == a.assign_role?.id)
  })
  return activities
})

function pick(d) {
  const data = d.data.map(d => {
    d.aligned_class = {
      'bi-check': d.aligned_by && d.aligned,
      'text-success': d.aligned_by && d.aligned,
      'bi-dot': d.aligned_by == null && d.assign_role != null,
      'text-warning': d.aligned_by == null && d.assign_role != null,
    }
    if (d.shipment_date_scheduled) {
      d.shipment_date_scheduled = commons.dateLocal(d.shipment_date_scheduled)
    }

    d.order_out = { status: '', dispatch_date_executed: '' }
    for (let ord of d.order) {
      if (ord.dispatch_date_executed) {
        d.order_out.dispatch_date_executed = commons.dateLocal(ord.dispatch_date_executed)
      }
      d.order_out.status += (d.order_out.status == '' ? '' : ', ') + ord.status.value
    }

    return d
  })
  return data
}
</script>
